import Vue from 'vue'
import Router from 'vue-router'
import routers from './routers'
import store from '@/vue/store'
import { ACCESS_TOKEN } from '@/vue/store/mutation-type'
import Dialog from 'vant/es/dialog'

Vue.use(Router)

const router = new Router({
  mode: 'hash',
  routes: [...routers]
})

router.beforeEach((to, from, next) => {
  if(Vue.ls.get(ACCESS_TOKEN)){
    if(to.path === '/login') {
      next({ path : '/home'})
    }else{
      next()
    }
  }else{
    console.log(9)
    if(to.path === '/login' || to.path === '/shixin'|| to.path === '/overdue'){
      next()
    }else{
      Dialog.alert({
        message: '登录失效，请重新登录'
      }).then(() => {
        next({ path : '/login'})
      });
    }
  }

});

//自定义指令集过滤权限
Vue.directive('action', {
  bind: function (el, binding, vnode) {
    const actionName = binding.arg
    const roles = store.getters.roles

    if(roles.indexOf(actionName) == -1) {
      el.parentNode && el.parentNode.removeChild(el) || (el.style.display = 'none')
    }
  }
})

//根据当前进件单状态显示不同按钮
Vue.directive('approval', {
  bind: function (el, binding, vnode) {
    const _status = binding.arg
    const auditStatus = store.getters.auditStatus

    if(_status.indexOf(auditStatus) != -1) {
      el.parentNode && el.parentNode.removeChild(el) || (el.style.display = 'none')
    }

  }
})



export default router
